export const VOLUNTEER_ROLES = ["fundraising_admin", "brand_rep", "hs_outreach", "backend_volunteer"];

export const VOLUNTEER_ROLE_LABELS = {
  fundraising_admin: "Fundraising Administrator",
  brand_rep: "Community Brand Representative",
  hs_outreach: "High School Outreach Volunteer",
  backend_volunteer: "Backend Fundraising Volunteer",
};

export const TASK_STATUS = {
  open: { label: "Open", cls: "bg-[#efe9dd] text-[#5a5849]" },
  in_progress: { label: "In progress", cls: "bg-[#f6ecd7] text-[#9c6a2e]" },
  done: { label: "Done", cls: "bg-[#e8e7d6] text-[#5f6a48]" },
};

export function homePath(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "supporter") return "/portal";
  return "/volunteer";
}

export const isManager = (u) => !!u && (u.role === "admin" || u.volunteer_role === "fundraising_admin");
